import { useAuth } from '@/hooks/use-auth/use-auth';
import PublicLayout from '@/layouts/public-layout/public.layout';
import { Navigate } from 'react-router-dom';

type PrivateRouteProps = {
  children: React.ReactNode;
};

export const PublicRoute = ({ children }: PrivateRouteProps) => {
  const { isAuthorized } = useAuth();

  return !isAuthorized ? <PublicLayout>{children}</PublicLayout> : <Navigate to="/" />;
};
